import C from "../../../constants";
import _ from 'lodash';

var constructPayload = function(store, question) {
    const state = store.getState();
    let email = _.get(state, ["clientRequest", "email"]);
    let recordId = _.get(state, ["clientRequest", "recordId"]);

    // Get the email and the recordId from the notes field if not found int he client request.
    // Right now in the demo, the user will only receive the client request on their cellphone, and hence
    // the email field on the Client Request might not always be populated, to avoid sending the clent request
    // link to both their cell and their email.
    // To combat this, we pass the cellphone number only to the client reqeust, and store the
    // email in the notes field as so: `email:test@attestiv.com`
    if (!email || !recordId) {
        let notesArr = _.get(state, ["clientRequest", "notes"]).split(",");
        for (let note of notesArr) {
            let noteArr = note.split(":");
            if (!email && noteArr[0] === "email") {
                email = noteArr[1].trim();
            }
            if (!recordId && noteArr[0] === "recordId"){
                recordId = noteArr[1];
            }
        }
    }

    return {
        email: email,
        recordId: recordId
    }

};

var handleResult = function(result, store, question) {
    console.info("ReportGenerator Result: " + result.data);
    store.dispatch({ type: C.NEXT_QUESTION });
}

var handleError = function(error) {
    console.error("ReportGenerator Error: " + error.message);
    if (error.stack) {
        console.error(error.stack);
    }
}

export {
    constructPayload,
    handleResult,
    handleError
};